/* import __COLOCATED_TEMPLATE__ from './option-contents.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();